module.exports = __webpack_public_path__ + "img/moodbuster-logo.4b538664.svg";